module.exports = __webpack_public_path__ + "static/media/headphones.a072329b.svg";